<script lang="ts">
  import PoundIcon from "../../components/icons/PoundIcon.svelte";
  import FileLight from "../../components/icons/FileLight.svelte";
  import BellIcon from "../../components/icons/BellIcon.svelte";
  import LargeButton from "../../components/buttons/LargeButton.svelte";
  import SmallInfoIcon from "../../components/icons/SmallInfoIcon.svelte";
  import TextNew from "../../components/TextNew.svelte";

  export let onContinue: () => void;
</script>

<div class="container">
  <div class="left">
    <TextNew size="xl" weight="medium">REKKI Insights Premium:<br />get 30 days free</TextNew>
    <div class="bullets">
      <div class="bullet">
        <div class="bullet-icon">
          <PoundIcon />
        </div>
        <TextNew size="s">real time breakdown of your spend and food costs</TextNew>
      </div>
      <div class="bullet">
        <div class="bullet-icon">
          <FileLight />
        </div>
        <TextNew size="s">easily upload invoices from any supplier</TextNew>
      </div>
      <div class="bullet">
        <div class="bullet-icon">
          <BellIcon />
        </div>
        <TextNew size="s">price change alerts for individual products</TextNew>
      </div>
    </div>
    <div class="footer">
      <div class="info">
        <div class="info-icon-container">
          <SmallInfoIcon />
        </div>

        <div class="info-text">
          <TextNew size="xxs" --rk-text-color="var(--rk-text-transparency-dark)" weight="medium"
            >if you want access for multiple sites, please email <a href="mailto:support@rekki.com"
              >support@rekki.com</a
            ></TextNew
          >
        </div>
      </div>
      <LargeButton title="continue" onClick={onContinue} />
    </div>
  </div>
  <div class="right">
    <img src="static/assets/premium-onboarding.svg" width="100%" alt="premium-onboarding" />
  </div>
</div>

<style>
  .container {
    display: flex;
    flex: 1;
  }
  .left,
  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    box-sizing: border-box;
    width: 50%;
  }

  .left {
    padding: 32px 24px 24px 24px;
  }

  .right img {
    height: 100%;
    width: 100%;
    display: block;
    object-fit: cover;
  }

  .bullets {
    margin-top: 36px;
  }

  .bullet {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 20px;
  }

  .bullet-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background-color: var(--rekki-neutral-04);
    border-radius: 20px;
    margin-right: 12px;
  }

  .info {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;
    padding: 6px 8px;
    background-color: var(--rekki-neutral-01);
    border-radius: 4px;
  }

  .info-icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
    border-radius: 9px;
    margin-right: 8px;
    background-color: white;
  }

  .info-text {
    color: var(--rekki-transparency-dark);
    margin-top: 2px;
  }

  a {
    color: var(--rekki-transparency-dark);
  }

  .footer {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    flex-grow: 1;
    width: 100%;
  }
</style>
